/* eslint-disable max-lines */
import { ITheme } from "../../utils/theme";

export const dispatchInfoTableStyle = (theme: ITheme) => ({
  '.MuiTableBody-root .MuiTableRow-root': {
    background: theme.palette.common.white,
    '&:nth-of-type(odd)': {
      background: theme.palette.blue[100]
    },
    ' .MuiTableCell-root': {
      textAlign: 'left',
      borderRight: `1px solid ${theme.palette.grey[300]}`,
      py: 1
    }
  },
  '.MuiTableFooter-root .MuiTableCell-root': {
    background: theme.palette.blue[200],
    p: 1,
    textAlign: 'center'
  }
})

export const redColorStyle = {
  color: (theme: ITheme) => theme.palette.error.light
}

export const greenColorStyle = {
  color: (theme: ITheme) => theme.palette.success.light
}

export const disclaimerStyle = {
  display: 'flex',
  color: (theme: ITheme) => theme.palette.neutralWhite,
  cursor: "pointer",
}

export const disclaimerContentStyle = {
  position: "absolute",
  zIndex: "999",
  top: "64px",
  left: 0,
  width: "100%"
}

export const tableWrapper = (height: number) => ({
  paddingTop: 2,
  paddingBottom: 2,
  paddingRight: 1,
  paddingLeft: 1,
  marginTop: 1,
  marginBottom: 4,
  overflow: 'auto',
  borderRadius: '5px',
  height: `calc(100% - ${height + 10}px)`,
})

export const backDropStyle = (theme: ITheme) => ({
  zIndex: theme.zIndex.drawer + 1,
  p: 1,
  border: `1px solid ${theme.palette.primary.main}`,
  background: theme.palette.grey[700],
  m: 1,
  mb: 0,
  borderTopWidth: 0,
  top: '56px',
  height: 'calc(100% - 64px)'
});

export const whiteWrapperStyle = {
  p: 1,
  height: '100%',
  borderRadius: '5px'
}

export const textWrapperStyle = (theme: ITheme) => ({
  border: `1px solid ${theme.palette.primary.main}`,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: (theme: ITheme) => theme.palette.error.dark,
  fontSize: { xs: '1rem', md: '1.5rem' },
  height: '100%',
  widht: '100%',
  p: 1
})

export const forecastTableStyle = (theme: ITheme) => ({
  borderCollapse: 'separate',
  borderSpacing: 0,
  ' > .MuiTableHead-root': {
    background: theme.palette.blue[200],
  },
  ' .MuiTableHead-root .MuiTableCell-root': {
    fontSize: '18px',
    fontWeight: 'bold',
  },
  ' .MuiTableCell-root': {
    color: theme.palette.grey.A200,
    fontSize: '16px',
    boxSizing: 'border-box',
    p: 1,
    textAlign: 'center',
    whiteSpace: { xs: 'nowrap', md: 'normal' },
    '&.noPadding': {
      p: 0
    },
    '&.alignRight': {
      textAlign: 'right',
    },
    '&.alignLeft': {
      textAlign: 'left',
    },
    '&:first-of-type': {
      textAlign: 'left',
      width: { xs: 'auto', md: '40%' },
      '&.noData': {
        textAlign: 'center'
      }
    },
    '&:first-of-type.shortageListFirstCell': {
      textAlign: 'left',
      padding: '0px',
      width: { xs: 'auto', md: '20%' },
      '&.noData': {
        textAlign: 'center'
      },
      '.MuiBox-root.redBackground': {
        background: theme.palette.red[750]
      }
    },
    '&.red': {
      color: theme.palette.red.A700,
    },
    '&.green': {
      color: theme.palette.success.light,
    },
    '&.greenBackground': {
      background: theme.palette.green[350]
    },
    '&.redBackground': {
      background: theme.palette.red[750]
    },
    '&.expand': {
      textDecoration: 'underline',
      cursor: 'pointer'
    },
    '&.open': {
      background: theme.palette.coldWhite,
    },
    '.availabilityTable ': {
      tableLayout: "auto",
      '& .MuiTableCell-root': {
        p: 0,
        px: 1,
        color: 'black',
        borderRight: `1px solid ${theme.palette.grey[300]}`,
        whiteSpace: 'normal',
        overflow: 'visible',
        '&.hasBoldBorder': {
          border: `2px solid ${theme.palette.common.black}`,
          boxSizing: 'border-box'
        }
      },
      '.MuiTableBody-root': {
        ' > .MuiTableRow-root': {
          '&:nth-child(4n+1)': {
            background: 'white'
          }
        }
      },
      '& .MuiTableBody-root .MuiTableRow-root': {
        '& > .MuiTableCell-root:nth-of-type(1)' : {
          width: '40%'
        },
        '& > .MuiTableCell-root:nth-of-type(2)' : {
          width: '30%'
        },
        '& > .MuiTableCell-root:nth-of-type(3)' : {
          width: '89px'
        },
        '& > .MuiTableCell-root:nth-of-type(4)' : {
          width: '170px'
        }
      },
    },
    '.shortageTable ': {
      '& .candidateRows': {
        '& .MuiTableCell-root': {
          p: 0,
          px: 1,
        }
      },
      '& .candidateRows:nth-of-type(odd)': {
        background: theme.palette.blue[100]
      },
      '& .candidateRows:nth-of-type(even)': {
        background: theme.palette.common.white
      },
      '& .MuiTableRow-root.erorrMsg': {
        border: `2px solid ${theme.palette.red.A700}`,
        '& .MuiTableCell-root': {
          pt: 4,
          pb: 4,
        }
      },
      '& .MuiTableCell-root': {
        color: 'black',
        border: `1px solid ${theme.palette.grey[300]}`,
        '&.hasBoldBorder': {
          border: `2px solid ${theme.palette.common.black}`,
          boxSizing: 'border-box'
        },
        '&.noBorder': {
          border: 'none',
        },
        '&.candidateList': {
          p: 0
        }
      }
    }
  },
  '.MuiTableBody-root': {
    ' > .MuiTableRow-root': {
      background: theme.palette.common.white,
      '&.subTableHeadRow': {
        background: (theme: ITheme) => theme.palette.blue[200]
      },
      '&.subTableRow': {
        background: (theme: ITheme) => theme.palette.success.main,
        '& .MuiTableCell-root': {
          whiteSpace: 'initial',
        }
      },
      '&.expand-row > .MuiTableCell-root': {
        p: 0,
        borderBottom: 0
      },
      '&.blueBg': {
        background: theme.palette.blue[150],
      },
      '&.topRedBorder > .MuiTableCell-root': {
        borderTop: `1px solid ${theme.palette.red.A700}`
      },
      '&.bottomRedBorder > .MuiTableCell-root': {
        borderBottom: `1px solid ${theme.palette.red.A700}`
      },
      '&.redBorder > .MuiTableCell-root:first-of-type': {
        borderLeft: `1px solid ${theme.palette.red.A700}`,
      },
      '&.redBorder > .MuiTableCell-root:last-of-type': {
        borderRight: `1px solid ${theme.palette.red.A700}`
      },
      '&:nth-child(4n+1)': {
        background: theme.palette.blue[100],
        '&.subTableRow': {
          background: (theme: ITheme) => theme.palette.success.main
        },
        '&.subTableHeadRow': {
          background: (theme: ITheme) => theme.palette.blue[200]
        },
        '&.blueBg': {
          background: theme.palette.blue[150],
        },
      },
    }
  }
})

export const legendStyle = {
  textDecoration: 'underline',
  float: 'right',
  display: 'flex',
  justifyContent: 'end',
  cursor: 'pointer',
  fontWeight: 'bold',
  width: '100%',
  '& svg': {
    ml: 1
  },
}


export const availabilityDisclaimerContentStyle = {
  position: "absolute",
  zIndex: "999",
  top: '40px',
  right: 0,
  width: { xs: '80vw', md: '50%' },
  whiteSpace: 'initial'
}

export const boxStyle = {
  width: '40px',
  minWidth: '40px',
  height: '40px',
  boxSizing: 'border-box',
  mr: 1,
}

export const boxWrapperStyle = {
  display: 'flex',
  mb: 1,
  alignItems: 'center',
  '&:last-of-type': {
    mb: 0
  }
}

export const warningIconStyle = (theme: ITheme) => ({
  zIndex: 'auto',
  position: 'relative',
  top: '3px',
  mr: 1,
  '& > path: first-of-type': {
    fill: theme.palette.yellow[300],
    opacity: 1,
  }
})

export const boardPlateStyle = (theme: ITheme) => ({
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: '4px',
  color: theme.palette.blue[900],
  fontWeight: 'bold',
  p: 0
})

export const squamishPlateStyle = (theme: ITheme) => ({
  border: `1px solid #5F462A`,
  borderRadius: '4px',
  color: theme.palette.blue[900],
  backgroundColor: '#E9DCCD',
  fontWeight: 'bold',
  p: 0
})

export const regularWorkForceStyle = (theme: ITheme) => ({
  border: `1px solid #B52934`,
  borderRadius: '4px',
  color: theme.palette.blue[900],
  backgroundColor: '#F7D9DB',
  fontWeight: 'bold',
  p: 0
})

export const phoneStyle = {
  textAlign: 'left'
}

export const boardRow = (theme: ITheme) => ({
  background: '#cce2f4',
  border: `1px solid ${theme.palette.common.white}`,
  borderRadius: '4px',
  position: 'relative',
})

export const shortageFilterWrapperStyle = {
  display: "flex",
  flexDirection: "row",
  background: (theme: ITheme) => theme.palette.blue[900],
}

export const shortageBoardTypeRadioContainerStyle = {
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginLeft: 3,
  marginRight: 3
}

export const shortageBoardTypeRadioLabelStyle = {
  color: (theme: ITheme) => theme.palette.common.white
}

export const shortageBoardTypeRadioStyle = {
  color: (theme: ITheme) => theme.palette.common.white,
  '&.Mui-checked': {
    color: (theme: ITheme) => theme.palette.red[300],
  },
}

export const SelectLabelStyle = {
  color: (theme: ITheme) => theme.palette.common.white,
  margin: "0 24px 8px 24px",
}

export const SelectStyle = {
  margin: "0 24px 16px 24px",
}

export const SelectMenuStyle = {
  maxHeight: { xs: 300, sm: 400, md: 500 }
}

export const TextFieldStyle = {
  "&.MuiTextField-root": {
    borderWidth: "3px",
    borderRadius: "4px",
  },
  "& .MuiInputBase-input": {
    padding: "8px 14px"
  },
}

export const CheckBoxLabelStyle = {
  color: (theme: ITheme) => theme.palette.common.white,
  margin: "0 24px 8px 24px",
}

export const CheckBoxStyle = {
  color: (theme: ITheme) => theme.palette.common.white,
  '&.Mui-checked': {
    color: (theme: ITheme) => theme.palette.common.white,
  },
}

export const headerCellStyle = {
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  color: 'black',
  fontWeight: 'bold',
  fontSize: 'medium'
}

export const closeButtonStyle = {
  display: 'flex',
  cursor: 'pointer',
  justifyContent: 'center',
  alignItems: 'center',
  border: '1px solid black',
  "&>svg": {
    fontSize: 'large',
  },
}

export const boardRowStyle = (theme: ITheme) => ({
  background: '#cce2f4',
  border: `1px solid ${theme.palette.common.white}`,
  borderRadius: '4px',
})

export const boardRowContainerStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  position: 'relative'
}

export const noDataStyle = {
  padding: 1,
  position: 'relative'
}

export const noDataFilterButtonStyle = {
  position: 'absolute',
  right: 0,
  top: 0
}

export const shiftPecentageText = {
  display: 'flex',
  justifyContent: 'space-between'
}

export const spaceRight = {
  marginRight: '8px'
}

export const makeAvailableStyle = (theme: ITheme) => ({
  textDecoration: 'underline',
  p: 0,
  border: 'none',
  background: 'none',
  cursor: 'pointer'
})

export const calledStyle = (theme: ITheme) => ({
  textDecoration: 'underline'
})

export const paginationStyles = {
  background: 'white',
  padding: 0,
  paddingTop: 1,
  paddingBottom: 1,
  display: 'flex',
  justifyContent: 'center',
}

export const jobDetailsButtonStyle = {
  position: 'absolute',
  top: '-7px',
  right: '-15px',
  textDecoration: 'underline',
  '&:hover': {
    background: 'transarent'
  }
}

export const checkBoxStyle = (theme: ITheme) => ({
  '&.Mui-checked': {
    color: theme.palette.blue[450],
    backgroundColor: theme.palette.common.white,
    height: 0,
    width: 0,
    borderRadius: '20%',
    margin: '10px',
    border: `2px solid ${theme.palette.common.black}`
  },
  '&.Mui-disabled': {
    color: theme.palette.grey['A350']
  }
})

export const disclaimerLabelStyle = {
  display: "flex",
  color: (theme: ITheme) => theme.palette.red[650],
  cursor: "pointer",
  mb: 1,
  "& p": {
    fontWeight: "bold",
  }
}